import { useState } from 'react';
import { useMasterCase } from 'pages/qa-spec/hooks/useMasterCase';
import { EDIT_SECTION } from 'pages/qa-spec/components/edit-tab-checker';
// import { useGetQaPhysicalChemicalSnapshot } from '../qa-prod-spec/snapshot/hooks';
import PackagingGrid from '../qa-prod-spec/PackagingGrid';
import { Typography } from 'antd';

const { Text } = Typography;

const MasterCase = (props) => {
  const { productId, enumOptions } = props;
  const [isGridEditing, setIsGridEditing] = useState(false);

  const {
    gridInst,
    rowData,
    columnDefs,
    saveData,
    cancelEdit,
    loading,
    addNewRow,
    deleteData,
    selectedRow,
    selectRow,
    onCellEditingStopped,
    gridTitle,
  } = useMasterCase({
    productId,
    enumOptions,
    isGridEditing,
  });

  // const { physicalChemicalSnapshot, analysisNotExecutedSnapshot } =
  //   useGetQaPhysicalChemicalSnapshot();

  const onEdit = (isEditing) => {
    setIsGridEditing(isEditing);
  };

  return (
    <PackagingGrid
      type={EDIT_SECTION.QA_PACKAGING_EPR}
      title={gridTitle}
      loading={loading}
      gridInst={gridInst}
      columnDefs={columnDefs}
      rowData={rowData}
      handleSave={saveData}
      handleAdd={addNewRow}
      handleDelete={deleteData}
      handleCancel={cancelEdit}
      selectedRow={selectedRow}
      onRowSelected={selectRow}
      productId={productId}
      onCellEditingStopped={onCellEditingStopped}
      //snapshotGridValues={physicalChemicalSnapshot}
      onEditChange={onEdit}
      fieldPathTooltip='qaSpecification.productSpecification.analysisNotExecuted2'
      isShowSubtitle={true}
      subtitle={
        <Text>
          List all materials that make up the packaging component
          <Text strong> (i.e. Card box, Inner pack)</Text> as master case level.
          If product contains multiple packaging components, click on the <Text strong>"Add"</Text> button to add multiple rows.
        </Text>
      }
    />
  );
};

export default MasterCase;
